import axios from '../config/axios';

/**
 * Update user password.
 *
 * @param {string} token - Auth token
 * @param {string} newPassword - New password to save
 * @returns {Promise<Object>} - Response data
 */
export default async function updatePassword(token, newPassword) {
  const { data } = await axios.put(
    '/password',
    { newPassword },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
}
